import { useRouter } from 'next/compat/router';

import type { AnalyticsEventPropertiesMap, AnalyticsEvents } from './events';

type PaywallViewedProperties =
  AnalyticsEventPropertiesMap[AnalyticsEvents.paywallViewed];

/**
 * FFH-3570: the route pattern a paywall opened on, for `origin_tab`. The
 * compat router returns null instead of throwing where no Next router is
 * mounted, so a padlock rendered outside a page still renders.
 */
export const usePaywallOriginTab = (): string | null =>
  useRouter()?.pathname ?? null;

/**
 * FFH-3570: the one place web paywalls build their `paywall_viewed`
 * properties. A web paywall gates the feature that opens it, so
 * `trigger_feature` repeats `feature`: `feature` stays for the insights
 * already built on it, and `trigger_feature` is the name the app sends too.
 */
export const toPaywallViewedProperties = ({
  placement,
  feature,
  originTab
}: {
  placement: string;
  feature: string;
  originTab: string | null;
}): PaywallViewedProperties => ({
  placement,
  feature,
  trigger_feature: feature,
  origin_tab: originTab
});
